import { withFormik } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { PaymentCard, GiftItem } from 'components/gifts-table';
import { Card } from 'components';
import { withStore } from 'store';
import { VERSIONS } from 'constants/versions';
import { useHistory } from 'react-router';
import styles from './styles.module.scss';
import { MOCK_DATA } from './mocks';

function StepThree({shoppingCartProducts=[] , tableInfo={}} ) {
  const history = useHistory();

  const handleClickFirstAction = () => {
    history.push('/');
  };

  const handleClickSecondAction = () => {
    history.push('/agregar-regalos');
  };

  return (
    <>
      <Row>
        <Col xs={12}>
          <h1 className="text-center my-5">
            Gracias por elegir tus productos con nosotros.
          </h1>
          <h2 className="text-center my-5 font-weight-bold text-primary">
          Tu regalo será enviado a {tableInfo?.name?.split('-').pop()}
          </h2>
        </Col>
        <Col lg={8} className="mb-3 d-flex justify-content-center">
          <Card className={styles.giftsCard}>
            <Row className="p-0 m-0">
              {shoppingCartProducts.map(({ id, ...product }) => (
                <Col key={id} xs={12} className="p-0 m-0">
                  <GiftItem
                    item={product}
                    id={id}
                    type="big"
                    stockMock
                    selected
                    version={VERSIONS.V2}
                    className={styles.giftItem}
                    onlyView
                  />
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
        <Col lg={4} className="d-flex justify-content-center mb-3">
          <PaymentCard
            firstActionLabel="Cerrar sesión"
            onClickFirstAction={handleClickFirstAction}
            onClickSecondAction={handleClickSecondAction}
          />
        </Col>
      </Row>
    </>
  );
}

export default withStore({
  mapStateToProps: (state) => ({
    shoppingCartProducts: state.externalGiftTable.shoppingCartProducts.data,
    tableInfo: state.externalGiftTable.giftTableInfo.data,
  }),
})(withFormik({ mapPropsToValues: () => ({}) })(StepThree));
